import { Component, OnInit, OnDestroy, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';

import { PartnershipDataGroup, RelationshipDataGroup } from '../../models/UserRelationship';
import { AssetGroupService } from '../../asset-group.service';

@Component({
  selector: 'app-edit-asset-group',
  templateUrl: './edit-asset-group.component.html',
  styleUrls: ['./edit-asset-group.component.scss']
})
export class EditAssetGroupComponent implements OnInit, OnDestroy {

  @Input() displayDialog: boolean;
  @Input() partnershipDataGroup: PartnershipDataGroup;
  @Output() onDialogHide = new EventEmitter<boolean>();
  @Output() onEdit = new EventEmitter<PartnershipDataGroup>();

  processing = false;
  subscription: any;
  editFormdata: RelationshipDataGroup;
  assetGroupExists = false;
  assetGroupVerification = false;

  public editForm: FormGroup = new FormGroup({
    RelationshipId: new FormControl('0'),
    RelationshipGroupId: new FormControl('0'),
    RelationshipGroupName: new FormControl('', [Validators.required]),
    Items: new FormControl('', [Validators.required]),
    Assigned: new FormControl('')
  });

  relationshipGroupNameControl = this.editForm.get('RelationshipGroupName');
  itemsControl = this.editForm.get('Items');

  constructor(private assetGroupSvc: AssetGroupService, private confirmationSvc: ConfirmationService) { }

  ngOnInit() {
    if (typeof this.partnershipDataGroup.RelationshipDataGroup.Assigned !== 'undefined') {
      for ( let i = 0, aData = this.partnershipDataGroup.RelationshipDataGroup.Assigned; i < aData.length; i++ ){
        aData[i].FullName = aData[i].LastName + ', ' + aData[i].FirstName;
      }
    }
    this.relationshipGroupNameControl.setValue(this.partnershipDataGroup.RelationshipDataGroup.RelationshipGroupName);
  }

  onSubmit() {
    if (this.editForm) {
      this.confirmationSvc.confirm({
        message: 'All changes made shall be applied to all Partner Users that are associated to this Asset Group. Are you sure you want to save changes?',
        accept: () => {
          this.processing = true;
          this.editFormdata = this.editForm.value;
          this.editFormdata.RelationshipId = this.partnershipDataGroup.RelationshipDataGroup.RelationshipId;
          this.editFormdata.RelationshipGroupId = this.partnershipDataGroup.RelationshipDataGroup.RelationshipGroupId;
          this.editFormdata.Assigned = this.partnershipDataGroup.RelationshipDataGroup.Assigned;
          this.subscription = this.assetGroupSvc.create(this.editFormdata)
            .subscribe((assetData)  => {
              this.onEdit.emit(assetData['data'][0]);
              this.processing = false;
              this.dialogHide();
          });
        }
      });
    }
  }

  onRelationshipGroupNameChange() {
    this.assetGroupExists = false;
    if (this.partnershipDataGroup.RelationshipDataGroup.RelationshipGroupName.valueOf() !== this.relationshipGroupNameControl.value) {
      this.assetGroupVerification = true;
      this.subscription = this.assetGroupSvc.assetGroupNameExists(this.relationshipGroupNameControl.value, this.partnershipDataGroup.RelationshipDataGroup.RelationshipId)
        .subscribe((res: any) => {
          this.assetGroupExists = res.data[0].ExistingGroup;
          this.assetGroupVerification = false;
        });
    }
  }

  dialogHide() {
    this.onDialogHide.emit(false);
  }

  dialogShow() { }

  ngOnDestroy() {
    if (this.subscription) { this.subscription.unsubscribe(); }
  }
}
